import makeStyles from '@mui/styles/makeStyles';
import type { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
    lineHeight: 'normal',
    marginBottom: theme.spacing(1),
  },
  description: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 400,
    lineHeight: 'normal',
    color: theme.palette.darkGrey.main,
  },
}));

export default useStyles;
